<template>
    <CardPage :section="12" :page="7" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            Great job! You’ve earned another sticker.
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section12/sticker')
    },
    methods: {
        finish() {
            this.$store.set('section12/sticker@earned', true);
        }
    }
};
</script>
